import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';
import { AuthGuard } from './guards/auth.guard';
import { AutoLoginGuard } from './guards/auto-login.guard';

const routes: Routes = [
    {
        path: 'login',
        loadChildren: () =>
            import('./pages/login/login.module').then((m) => m.LoginPageModule),
        canLoad: [AutoLoginGuard],
    },
    {
        path: 'home',
        loadChildren: () =>
            import('./pages/home/home.module').then((m) => m.HomePageModule),
        canLoad: [AuthGuard],
    },
    {
        path: '',
        redirectTo: '/login',
        pathMatch: 'full',
    },
    {
        path: 'mi-qr',
        loadChildren: () =>
            import('./pages/mi-qr/mi-qr.module').then((m) => m.MiQrPageModule),
    },
    {
        path: 'upload-document',
        loadChildren: () =>
            import('./pages/upload-document/upload-document.module').then(
                (m) => m.UploadDocumentPageModule
            ),
    },
    {
        path: 'list-documents',
        loadChildren: () =>
            import('./pages/list-documents/list-documents.module').then(
                (m) => m.ListDocumentsPageModule
            ),
    },
    {
        path: 'list-documents/:folder',
        loadChildren: () =>
            import('./pages/list-documents/list-documents.module').then(
                (m) => m.ListDocumentsPageModule
            ),
    },
    {
        path: 'home-employees',
        loadChildren: () =>
            import('./pages/home-employees/home-employees.module').then(
                (m) => m.HomeEmployeesPageModule
            ),
        canLoad: [AuthGuard],
    },
    {
        path: 'turnos',
        loadChildren: () =>
            import('./pages/turnos/turnos.module').then(
                (m) => m.TurnosPageModule
            ),
        canLoad: [AuthGuard],
    },
    {
        path: 'vacaciones',
        loadChildren: () =>
            import('./pages/vacaciones/vacaciones.module').then(
                (m) => m.VacacionesPageModule
            ),
        canLoad: [AuthGuard],
    },
    {
        path: 'gastos',
        loadChildren: () =>
            import('./pages/gastos/gastos.module').then(
                (m) => m.GastosPageModule
            ),
    },
    {
        path: 'resume',
        loadChildren: () =>
            import('./pages/resume/resume.module').then(
                (m) => m.ResumePageModule
            ),
    },
    {
        path: 'digitalize-invoice',
        loadChildren: () =>
            import('./pages/digitalize-invoice/digitalize-invoice.module').then(
                (m) => m.DigitalizeInvoicePageModule
            ),
    },
    {
        path: 'add-qr',
        loadChildren: () =>
            import('./pages/add-qr/add-qr.module').then(
                (m) => m.AddQrPageModule
            ),
    },  {
    path: 'registro-tiempo',
    loadChildren: () => import('./pages/registro-tiempo/registro-tiempo.module').then( m => m.RegistroTiempoPageModule)
  },

];

@NgModule({
    imports: [
        RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules }),
    ],
    exports: [RouterModule],
})
export class AppRoutingModule {}
